// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cm-j";
export var fulfillmentFormRail = "_cm-i";
export var headerTitleRow = "_cm-l";
export var orderDetailsWrapper = "_cm-g";
export var orderLinkTrigger = "_cm-2";
export var paymentInformationGrid = "_cm-q";
export var paymentSummaryColumn = "_cm-r";
export var phoneShipmentPickerButton = "_cm-e";
export var phoneShipmentPickerButtonContent = "_cm-f";
export var phoneShipmentPickerButtonWrapper = "_cm-d";
export var phoneShipmentPickerTrigger = "_cm-c";
export var shipmentContainer = "_cm-k";
export var shipmentDetailsMainPane = "_cm-h";
export var shipmentNavigationCard = "_cm-a";
export var shipmentNavigationEdgeTrigger = "_cm-6";
export var shipmentNavigationRail = "_cm-3";
export var shipmentNavigationRailEnter = "_cm-5";
export var shipmentNavigationRailHeader = "_cm-9";
export var shipmentNavigationRailOverlay = "_cm-4";
export var shipmentNavigationScrim = "_cm-7";
export var shipmentSummaryFact = "_cm-n";
export var shipmentSummaryGrid = "_cm-m";
export var shipmentSummaryMetadataRow = "_cm-o";
export var shipmentSummaryTags = "_cm-p";
export var shipmentWorkspace = "_cm-0";
export var shipmentWorkspaceBodyTablet = "_cm-8";
export var shipmentWorkspaceContent = "_cm-b";
export var shipmentWorkspaceHeader = "_cm-1";